import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformGetCurrentUserMockHandler = () => {
  return http.get('*/user', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    return HttpResponse.json(
      {
        created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
        email: 'admin@localhost',
        id: faker.string.uuid(),
        name: 'Admin',
        profile_image_url: null,
        updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
      },
      {
        status: 200,
      },
    );
  });
};
